import { ErrorFieldProps } from './ErrorField.props';
import s from './ErrorField.module.css';
import cn from 'classnames';

export const ErrorField = ({error}: ErrorFieldProps ): JSX.Element => {

  return  <p className={cn("error", s.error)}>{error}</p>;
};
